import { useState } from "react";
import { motion } from "framer-motion";
import { Send } from "lucide-react";
import { toast } from "sonner";
import ScrollReveal from "@/components/3d/ScrollReveal";
import MagneticButton from "@/components/3d/MagneticButton";

const Newsletter = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      toast.success("You're in! Welcome to the Grovefan fam.");
      setEmail("");
    }
  };

  return (
    <section className="relative border-t border-border/50 py-24 overflow-hidden">
      {/* Animated background orbs */}
      <motion.div
        className="absolute left-1/4 top-0 h-64 w-64 rounded-full bg-primary/5 blur-[100px]"
        animate={{ y: [0, 30, 0], x: [0, 20, 0] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute right-1/4 bottom-0 h-64 w-64 rounded-full bg-accent/5 blur-[100px]"
        animate={{ y: [0, -20, 0], x: [0, -15, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="container relative mx-auto px-4 text-center">
        <ScrollReveal direction="up">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary">Stay Connected</p>
          <h2 className="mt-2 font-display text-3xl font-bold sm:text-4xl">Join the Movement</h2>
          <p className="mx-auto mt-4 max-w-md text-sm text-muted-foreground">
            Get early access to drops, exclusive discounts, and behind-the-scenes content.
          </p>
          <form onSubmit={handleSubmit} className="mx-auto mt-8 flex max-w-md gap-2">
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 rounded-full border border-border bg-secondary px-5 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-all"
              required
            />
            <MagneticButton strength={0.3}>
              <button
                type="submit"
                aria-label="Subscribe"
                className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 glow-purple"
              >
                <Send className="h-4 w-4" />
              </button>
            </MagneticButton>
          </form>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Newsletter;
